import { DOCUMENT } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { ContentComponent } from './core/components/content/content.component';
import { HeaderComponent } from './core/components/header/header.component';
import { LeftNavComponent } from './core/components/left-nav/left-nav.component';
import { AppUpdateService } from './core/services/app-update.service';
import { SetCompanyId } from './shared/state/domain-context/domain-context.action';

@Component({
  selector: 'kp-app',
  imports: [RouterOutlet, HeaderComponent, LeftNavComponent, ContentComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  #appUpdateService = inject(AppUpdateService)
  #titleService = inject(Title)
  #document = inject(DOCUMENT)
  #store = inject(Store)

  title = 'Kundportalen';
  favIconBasePath = 'assets/images/'

  ngOnInit() {
    this.#appUpdateService.start()

    this.setBrowserTitle()
    this.setFavicon()
    this.setDomainContext()
  }

  private setDomainContext() {
    const url = new URL(window.location.href);
    const host = url.hostname.toLowerCase();
    const domainQuery = url.searchParams.get('d')?.toLowerCase();
    const isMfDomain = host.includes('mockfjards') || domainQuery === 'mf';

    this.#store.dispatch(new SetCompanyId(isMfDomain ? 'mf' : 'svf'));
  }

  private setFavicon() {

    const domain = window.location.href

    let link: HTMLLinkElement | null = this.#document.querySelector("link[rel*='icon']");

    if (!link) {
      link = this.#document.createElement('link');
      link.setAttribute('rel', 'icon');
      this.#document.head.appendChild(link);
    }

    const iconName =
      domain.includes('mockfjards') || domain.includes('?d=mf')
        ? 'favicon_mf.ico'
        : 'favicon_sf.ico';

    const faviconPath = this.favIconBasePath + iconName;

    link.setAttribute('href', faviconPath);
  }

  private setBrowserTitle() {

    const domain = window.location.href

    const title = domain.includes('mockfjards') || domain.includes('?d=mf') ?
      'Mockfjärds - Kundportalen'
      :
      'Svenska Fönster - Kundportalen'

    this.#titleService.setTitle(title)
  }
}
